export default {
  DeptCode: "",
  Description: "",
  DefaultAccount: "",
  UserModified: localStorage.getItem("UserName"),
};
